import { SxProps, Theme } from "@mui/material";

export const pageSx: SxProps<Theme> = {
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#ffffff",
  boxSizing: "border-box",
  p: { xs: "16px", md: "24px 32px" },
  pt: "64px",
  "@media print": {
    minHeight: "auto !important",
    backgroundColor: "#ffffff !important",
    p: "0 !important",
  },
};

export const actionsSx: SxProps<Theme> = {
  position: "fixed",
  top: "16px",
  left: "16px",
  zIndex: (theme) => theme.zIndex.appBar,
  borderRadius: "999px",
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(6px)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
  "@media print": {
    display: "none !important",
  },
};

export const exportActionsSx: SxProps<Theme> = {
  position: "fixed",
  top: "16px",
  right: "16px",
  zIndex: (theme) => theme.zIndex.appBar,
  display: "flex",
  alignItems: "center",
  gap: "4px",
  px: "8px",
  py: "2px",
  borderRadius: "999px",
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(6px)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
  "@media print": {
    display: "none !important",
  },
};

export const documentSx: SxProps<Theme> = {
  width: "100%",
  maxWidth: "1280px",
  mx: "auto",
  flex: 1,
  backgroundColor: "#ffffff",
  color: "#111827",
  "@media print": {
    width: "100% !important",
    maxWidth: "none !important",
    boxSizing: "border-box",
    p: "12mm !important",
    boxDecorationBreak: "clone",
    WebkitBoxDecorationBreak: "clone",
    color: "#000000 !important",
  },
};

export const headerSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 1fr) 200px" },
  alignItems: "center",
  gap: { xs: "12px", md: "24px" },
  pb: "8px",
  borderBottom: "1px solid #d1d5db",
  "@media print": {
    gridTemplateColumns: "40mm minmax(0, 1fr)",
    columnGap: "6mm",
    rowGap: "0",
    pb: "2mm",
    mb: "2.5mm",
    borderBottom: "1px solid #d1d5db",
    breakAfter: "avoid",
    pageBreakAfter: "avoid",
  },
};

export const headerContentSx: SxProps<Theme> = {
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  alignItems: { xs: "flex-start", md: "center" },
  textAlign: { xs: "left", md: "center" },
  "@media print": {
    alignItems: "center",
    textAlign: "center",
  },
};

export const generatedInfoSx: SxProps<Theme> = {
  display: "block",
  color: "#6b7280",
  fontSize: "12px",
  whiteSpace: "nowrap",
  "@media print": {
    color: "#000000 !important",
    fontSize: "8pt",
  },
};

export const logoContainerSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flex: "0 0 auto",
  width: "auto",
  "@media print": {
    justifySelf: "start",
    width: "auto",
    justifyContent: "flex-start",
  },
};

export const logoSx: SxProps<Theme> = {
  display: "block",
  width: "auto",
  maxWidth: { xs: "150px", sm: "170px", md: "190px" },
  maxHeight: { xs: "48px", sm: "54px" },
  objectFit: "contain",
  objectPosition: "center left",
  "@media print": {
    maxWidth: "40mm",
    maxHeight: "13mm",
  },
};

export const codeSx: SxProps<Theme> = {
  display: "block",
  mt: "4px",
  color: "#6b7280",
  fontSize: "12px",
  fontWeight: 700,
  "@media print": {
    color: "#000000 !important",
  },
};

export const titleSx: SxProps<Theme> = {
  m: 0,
  color: "#111827",
  lineHeight: 1.2,
  textWrap: "balance",
  "@media print": {
    color: "#000000 !important",
    fontSize: "18pt !important",
    lineHeight: "1.2 !important",
  },
};

export const filtersSummarySx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "max-content minmax(0, 1fr)",
  alignItems: "baseline",
  columnGap: "12px",
  rowGap: "4px",
  mt: "10px",
  mb: "10px",
  "@media print": {
    columnGap: "3mm",
    rowGap: "1mm",
    m: "0 0 2.5mm",
    breakAfter: "avoid",
    pageBreakAfter: "avoid",
  },
};

export const filtersSummaryItemSx: SxProps<Theme> = {
  display: "contents",
};

export const filtersSummaryLabelSx: SxProps<Theme> = {
  color: "#111827",
  fontSize: "13px",
  fontWeight: 700,
  "@media print": {
    color: "#000000 !important",
  },
};

export const filtersSummaryChipsSx: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  "@media print": {
    gap: "1mm",
  },
};

export const filtersSummaryChipSx: SxProps<Theme> = {
  display: "inline-block",
  px: "8px",
  py: "1px",
  border: "1px solid #d1d5db",
  borderRadius: "4px",
  backgroundColor: "#f3f4f6",
  color: "#374151",
  fontSize: "12px",
  lineHeight: 1.5,
  printColorAdjust: "exact",
  WebkitPrintColorAdjust: "exact",
  "@media print": {
    px: "1.5mm",
    py: 0,
    borderColor: "#9ca3af",
    color: "#000000 !important",
    fontSize: "8pt",
  },
};

export const filtersSummaryTextSx: SxProps<Theme> = {
  color: "#374151",
  fontSize: "13px",
  lineHeight: 1.5,
  overflowWrap: "anywhere",
  "@media print": {
    color: "#000000 !important",
    lineHeight: 1.4,
  },
};

export const loadingSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 220,
  gap: "12px",
  color: "#4b5563",
  "@media print": {
    display: "none !important",
  },
};

export const emptySx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 120,
  gap: "12px",
  color: "#4b5563",
  "@media print": {
    breakInside: "avoid",
    pageBreakInside: "avoid",
  },
};

export const tableWrapperSx: SxProps<Theme> = {
  width: "100%",
  overflowX: "auto",
  "@media print": {
    overflow: "visible !important",
  },
};

export const groupedReportGroupSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  mb: "24px",
  "@media print": {
    breakInside: "avoid",
    pageBreakInside: "avoid",
    gap: "4mm",
    mb: "6mm",
  },
};

export const groupedReportGroupHeaderSx: SxProps<Theme> = {
  color: "#111827",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: 1.4,
  "@media print": {
    color: "#000000 !important",
    fontSize: "11pt",
    breakAfter: "avoid",
    pageBreakAfter: "avoid",
  },
};

export const tableSx: SxProps<Theme> = {
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  tableLayout: "auto",
  fontSize: "13px",
  boxSizing: "border-box",
  printColorAdjust: "exact",
  WebkitPrintColorAdjust: "exact",
  "& th, & td": {
    p: "7px 12px",
    border: "none",
    textAlign: "left",
    verticalAlign: "top",
    boxSizing: "border-box",
  },
  "& th": {
    backgroundColor: "#dde1e6",
    borderBottom: "2px solid #9ca3af",
    color: "#111827",
    fontWeight: 700,
  },
  "& td": {
    color: "#1f2937",
    overflowWrap: "anywhere",
  },
  "& tbody tr:nth-of-type(even) td": {
    backgroundColor: "#ebedf0",
  },
  "@media (hover: hover)": {
    "& tbody td": {
      transition: "background-color 0.15s ease",
    },
    "& tbody tr:hover td": {
      backgroundColor: "#dbe7fb",
    },
  },
  "& tr": {
    breakInside: "avoid",
    pageBreakInside: "avoid",
  },
  "@media print": {
    width: "100% !important",
    fontSize: "9pt",
    tableLayout: "fixed",
    "& thead": {
      display: "table-header-group",
    },
    "& tfoot": {
      display: "table-footer-group",
    },
    "& th, & td": {
      p: "1.2mm 2.5mm",
      color: "#000000 !important",
      wordBreak: "normal",
      overflowWrap: "anywhere",
    },
    "& col": {
      boxSizing: "border-box",
    },
  },
};

export const totalRowSx: SxProps<Theme> = {
  "& td": {
    fontWeight: 700,
    backgroundColor: "transparent !important",
    borderTop: "2px solid #9ca3af",
  },
};
